document.addEventListener("DOMContentLoaded", function () {
    // Obtiene el path actual (por ejemplo, "/pages/top-questions")
    var currentPath = window.location.pathname.toLowerCase();

    // Selecciona todos los menús con clase "sidebar-menu"
    var sidebarMenus = document.querySelectorAll(".sidebar-menu");

    sidebarMenus.forEach(function (menu) {
        // Para cada menú, obtiene todos los <li>
        var liItems = menu.querySelectorAll("li");
        liItems.forEach(function (li) {
            // Busca el enlace <a> dentro del li
            var link = li.querySelector("a");
            if (link) {
                // Obtiene el href y lo pasa a minúsculas para comparación
                var linkHref = link.getAttribute("href").toLowerCase();
                // Si el path actual es exactamente igual al href, añade la clase "active"
                if (currentPath === linkHref) {
                    li.classList.add("active");
                }
            }
        });
    });
});